export const UPDATE = 'update' as const;

export interface RecordCollectionEvent extends CustomEvent{
    detail: never;
}

export interface RecordCollectionEventMap {
    [UPDATE]: RecordCollectionEvent;
}